'use strict';

var LOG_PREFIX = '[LiveShopping:Bambuser]';
var LOG_ENABLED = false;

function emitLog (method, args) {
    if (!LOG_ENABLED || !window.console || typeof window.console[method] !== 'function') {
        return;
    }

    var normalizedArgs = [LOG_PREFIX];
    for (var i = 0; i < args.length; i++) {
        normalizedArgs.push(args[i]);
    }

    window.console[method].apply(window.console, normalizedArgs);
}

export function logInfo () {
    emitLog('info', Array.prototype.slice.call(arguments));
}

export function logWarn () {
    emitLog('warn', Array.prototype.slice.call(arguments));
}

export function logError () {
    emitLog('error', Array.prototype.slice.call(arguments));
}
